<template>
    <div class="domain-review-table">
        <el-table :data="displayedItems" stripe class="domain-table" :show-overflow-tooltip="false" table-layout="auto"
            :empty-text="loading ? 'Đang tải...' : 'Không có dữ liệu'" :span-method="tableSpanMethod" max-height="600"
            :row-class-name="tableRowClassName">

            <el-table-column prop="periodLabel" label="Thời gian" min-width="140">
                <template slot-scope="{row}">
                    <div v-if="row._isBanner" class="guidance-banner">
                        <div class="guidance-content">
                            <span class="icon-left" aria-hidden="true">🚀</span>
                            <span v-if="requiredExp !== 0" class="guidance-text">
                                Tiến về đích! Hãy chinh phục
                                <strong class="emph">{{ targetScore }} điểm</strong>, tối thiểu
                                <strong class="emph">{{ requiredExp }} điểm</strong> để bứt phá lên level mới – mỗi nỗ lực của bạn đang
                                viết nên một hành trình rực rỡ
                                <span class="tail-emoji" aria-hidden="true">😍</span>
                            </span>
                            <span v-else class="guidance-text">
                                Về đích! Mỗi nỗ lực của bạn đang viết nên một hành trình rực rỡ
                                <span class="tail-emoji" aria-hidden="true">😍</span>
                            </span>
                        </div>
                    </div>
                    <span v-else>Quý {{convertToRoman(row.quarter)}}/{{row.year}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Team" min-width="160">
                <template slot-scope="{row}">
                    <span>{{row.department?.name || '-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Level hiện tại" min-width="180">
                <template slot-scope="{row}">
                    <span>{{row.current_level?.level || '-'}}</span>
                </template>
            </el-table-column>

            <el-table-column label="Điểm KRA" min-width="130">
                <template slot-scope="{ row }">
                    <el-tooltip
                        v-if="row.kra_score"
                        effect="light"
                        placement="top"
                        :content="'Giải thích: Tổng điểm/ điểm tối đa của tiêu chí'"
                    >
                        <span style="cursor: pointer" :class="row.kra_score < 10 ? 'text-danger': 'text-success'">{{ parseInt(row.kra_score) }}/100</span>
                    </el-tooltip>
                    <span v-else class="text-danger">0/100</span>
                </template>
            </el-table-column>
            <el-table-column label="Điểm họp" min-width="120">
                <template slot-scope="{row}">
                    <span v-if="row.meeting_points" :class="row.meeting_points < 10 ? 'text-danger': 'text-success'">{{ row.meeting_points }}/10</span>
                    <span v-else class="text-danger">0/10</span>
                </template>
            </el-table-column>
            <el-table-column label="Điểm EXP" min-width="120">
                <template slot-scope="{row}">
                    <span>{{ row.exp_points || '0' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="Điểm trừ" min-width="120">
                <template slot-scope="{ row }">
                    <el-popover
                        v-if="row.total_minus_point > 0"
                        placement="right"
                        trigger="click"
                        width="360"
                        @show="getDetailMinusPoint(row)"
                    >
                        <div v-if="row._minusLoading" class="py-2 text-center">
                            <i class="el-icon-loading"></i> Đang tải...
                        </div>

                        <el-empty
                            v-else-if="!row.minus_point || row.minus_point.length === 0"
                            description="Không có chi tiết"
                        />

                        <el-table v-else :data="row.minus_point" border size="mini">
                            <el-table-column prop="point" label="Số điểm trừ" width="120" />
                            <el-table-column prop="description" label="Chi tiết" />
                        </el-table>
                        <span
                            slot="reference"
                            class="cursor-pointer"
                            :class="row.total_minus_point > 0 ? 'text-danger' : 'text-success'"
                        >
                                  -{{ row.total_minus_point }}
                                </span>
                    </el-popover>
                    <span v-else :class="row.total_minus_point > 0 ? 'text-danger' : 'text-success'">
                      {{ row.total_minus_point }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="Tổng điểm" min-width="140">
                <template slot-scope="{ row }">
                    <el-tooltip v-if="row.top_company?.total_score" content="Giải thích: Tổng điểm / điểm cần đạt để tăng level" placement="top" effect="light">
                        <span style="color: #4D1EAB; font-weight: 600;">{{ parseInt(row.top_company.total_score) }}/ {{ row.requested_level.score }}</span>
                    </el-tooltip>
                    <span v-else class="text-danger">0/ {{ row.requested_level.score }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Kết quả" min-width="200">
                <template slot-scope="{ row }">
                    <div class="w-100" style="font-weight: 700" :class="expectedDefineColor[row.approve_type]">
                        {{ expectedDefineText[row.approve_type] }}
                        <i style="font-weight:800" :class="expectedDefineIcon[row.approve_type]"></i>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Level mới" min-width="200">
                <template slot-scope="{row}">
                    <span>{{ row.requested_level?.level || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="Mục tiêu level tiếp theo" min-width="220">
                <template slot-scope="{ row }">
                    <span>{{ row.level_target?.level || '-' }}</span>
                </template>
            </el-table-column>
            <template slot="empty">
                <div v-if="loading" class="loading-body">
                    <i class="el-icon-loading"></i>
                    <span>Đang tải...</span>
                </div>
            </template>
        </el-table>
    </div>
</template>

<script>
import {
    GET_DETAIL_MINUS_POINT,
} from "@/core/services/store/progress-level/progressLevel.module";
export default {
    name: 'DomainProgressReviewTable',
    components: {
    },
    props: {
        items: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    data() {
        return {
            expectedDefineIcon: { 0:'', 1:'el-icon-top', 2:'el-icon-bottom', 3:'fas fa-square' },
            expectedDefineText: { 0:'', 1:'Tăng Level',  2:'Giảm Level', 3:'Giữ Nguyên Level' },
            expectedDefineColor:{ 0:'', 1:'text-success', 2:'text-danger', 3:'text-warning' },
        };
    },
    computed: {
        displayedItems() {
            if (this.loading) return [];
            if (!this.items || this.items.length === 0) return [];
            const bannerRow = { _isBanner: true, id: '__banner__' };
            return [bannerRow, ...(this.items || [])];
        },
        latestRow() {
            // Lấy row gần nhất (đầu tiên trong danh sách)
            return this.items && this.items.length > 0 ? this.items[0] : null;
        },
        targetScore() {
            // 140 thay = row.requested_level.score
            return this.latestRow?.requested_level?.score || 140;
        },
        requiredExp() {
            if (!this.latestRow) return 30;
            
            const kraScore = this.latestRow.kra_score || 0;
            const meetingPoints = this.latestRow.meeting_points || 0;
            const expPoints = this.latestRow.exp_points || 0;
            const totalMinusPoint = this.latestRow.total_minus_point || 0;
            const targetScore = this.latestRow.requested_level?.score || 140;
            
            const currentTotal = kraScore + meetingPoints + expPoints - totalMinusPoint;
            const required = targetScore - currentTotal;
            
            return Math.max(0, Math.round(required));
        }
    },
    methods: {
        convertToRoman(num) {
            const romanNumerals = {
                1: 'I',
                2: 'II',
                3: 'III',
                4: 'IV'
            };
            return romanNumerals[num] || num;
        },
        tableSpanMethod({ row, column, rowIndex, columnIndex }) {
            // Merge all columns for banner row into one full-width cell
            if (row && row._isBanner) {
                if (columnIndex === 0) {
                    return { rowspan: 1, colspan: 9999  };
                }
                return { rowspan: 0, colspan: 0 };
            }
        },
        tableRowClassName({ row }) {
            return row && row._isBanner ? 'is-banner-row' : '';
        },
        getDetailMinusPoint(item){
            this.$set(item, '_minusLoading', true);
            const payload = {
                user_id: item.user_id,
                year: item.year,
                quarter: item.quarter,
            };
            this.$store.dispatch(GET_DETAIL_MINUS_POINT, payload).then(res => {
                item.minus_point = res?.data;
                this.$set(item, '_minusLoading', false);
            }).catch(e => {
                console.error(e);
            });
        }
    }
};
</script>

<style lang="scss" scoped>

.loading-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #666;

    i {
        font-size: 24px;
        margin-bottom: 12px;
        animation: rotating 2s linear infinite;
    }

    span {
        font-size: 14px;
    }
}

@keyframes rotating {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.guidance-banner {
  padding: 0;
  margin: 0;
  width: 100%;

  .guidance-content {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 0;

    /* màu tím chủ đạo */
    color: #4d1eab;

    .guidance-icon { font-size: 18px; color: #4d1eab; }

    .guidance-text {
      font-size: 13px;
      font-weight: 500;
      line-height: 1.5;
      color: #4d1eab;
    }

    .emph {
      color: #4d1eab;
      font-weight: 800;
      font-style: italic;
    }

    .tail-emoji {
      opacity: .95;
      font-size: 18px;
      margin-left: 6px;
    }

    .icon-left {
      font-size: 18px;
      margin-right: 6px;
      line-height: 1;
    }
  }
}

/* Đảm bảo banner phủ full hàng (nếu bạn đang render trong hàng gộp ô) */
.banner-row /deep/ .cell {
  padding: 0 !important;
  background: #FFF7E6 !important;
}
/* Ẩn ô gutter để không hở nền bên phải */
.banner-row /deep/ td.gutter { display: none !important; }


/deep/ .domain-table .el-table__header th,
/deep/ .domain-table .el-table__body td,
/deep/ .domain-table .el-table__header th .cell,
/deep/ .domain-table .el-table__body td .cell {
    white-space: normal !important;
    word-break: keep-all !important;
    overflow: visible !important;
    max-width: none !important;
    height: auto !important;
    text-align: center !important;
}

/* Full-row background for banner row */
/deep/ .domain-table .el-table__body tr.is-banner-row>td {
    background: rgba(253, 186, 116, 0.25) !important;
    /* soft amber */
}

/deep/ .domain-table .el-table__header th {
    background: #4d1eab !important;
    color: #fff !important;
    border-color: #4d1eab !important;
    line-height: 1.4 !important;
    padding: 16px 8px !important;
    height: 80px !important;
}

/deep/ .domain-table .el-table__body td {
    line-height: 1.3 !important;
    padding: 8px 4px !important;
    height: auto !important;
}

.action-buttons {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
}

.action-icon {
    font-size: 16px;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.2s ease;

    &.view-icon {
        color: #4d1eab;

        &:hover {
            background: rgba(77, 30, 171, 0.1);
            color: #6d28d9;
        }
    }

    &.edit-icon {
        color: #059669;

        &:hover {
            background: rgba(5, 150, 105, 0.1);
            color: #10b981;
        }
    }
}
.icon-circle.has-dot::after{
    content:""; position:absolute; top:-3px; right:-2px;
    width:10px; height:10px; background:#ff3b30; border-radius:50%;
    border:2px solid #fff;
}
.icon-circle{ position:relative; /* để ::after định vị theo vòng tròn */ }

/* Đảm bảo bảng fill hết width */
.domain-review-table {
    width: 100%;
}

.domain-table {
    width: 100% !important;
}

/* Cải thiện responsive cho các cột */
/deep/ .domain-table .el-table__header th,
/deep/ .domain-table .el-table__body td {
    padding: 12px 8px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
}

/* Đảm bảo banner vẫn hiển thị đầy đủ */
/deep/ .domain-table .el-table__body tr.is-banner-row>td {
    white-space: normal !important;
    overflow: visible !important;
}
</style>
